import {
  Applicant,
  ApplicantAddressType,
  ApplicationProps,
  Bank,
  Groups,
  JointholderRelationMaster,
  StrategyDetailsType,
  getDetailsByRefrenceType,
} from '../redux-store/types/api-types';
import {
  ACCOUNT_TYPE_OPTIONS,
  AMC_AUTHORISED_SIGNATORY_STATUS,
  APMIFlow,
  APPLICANT_STATUS,
  applicantStatusMasters,
  APPLICATION_LISTING_STATUS,
  APPLICATION_STATUS,
  APPLICATION_TYPE,
  BloodRelations,
  distributorMaster,
  FeeDetailTypeMasters,
  maritalStatusMasters,
  NDPSMBankMaster,
  nomineeIdTypes,
  removePermanentAddress,
  ROLE_TIMELINE,
  SALT,
  SALT2,
  SAVE_LATER_VALIDATION_CHECK,
  USER_ROLES,
  YesNoMaster,
} from './constant';
import { ToWords } from 'to-words';
import { individualPanRegex, nonIndividualPanRegex, numberRegex } from './regex';
import _ from 'lodash';
import { updatedStrategyDetails } from '../components/investors/strategyDetails';
import { updatedRiskProfile } from '../components/investors/riskProfileDetails';
import { useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import { useHistory } from 'react-router';
import { InvestorEditErrorObj } from '../redux-store/reducers/investorEditSections';
import { getApplicant } from '../components/ApplicationDetails/typeDeclaration';
import { getAuthorizedSignatories } from '../components/SignatoriesInvestments/signatories-application';
import {
  getAuthorizedSignatoriesConsentDetails,
  getConsentDetails,
} from '../components/dashboard/applicationslist';
import { updatedBank } from '../components/investors/bankDetails';
import { GetStrategiesResponseBody } from '../redux-store/types/strategies';
import { getStrategies, strategiesParams } from '../redux-store/actions/strategies';
import {
  investorEditDisclosureOfExclusionObj,
  investorEditDisclosureOfInterestObj,
  investorEditDocumentDetailsObj,
  investorEditEndpointExcludingDoc,
  investorEditEndpointIncludingDoc,
  investorEditRiskProfileObj,
} from '../components/investors/components';
import { checkTypedDeclaration } from '../components/Investments/investor-application';

export const documentTypeValidationCheckForDocumentNumberDocumentExpiryDate = (
  documentType: string
) => {
  return ['identityProof', 'addressProof', 'correspondenceAddress'].includes(documentType);
};

export const documentNameValidationCheckForDocumentExpiryDate = (docName: string) => {
  return ['Passport', 'Driving license'].includes(docName);
};

export const maskMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return '';
  }
  return (
    mobileNumber.slice(0, 2) +
    mobileNumber.slice(2, mobileNumber.length - 2).replace(/\d/g, '*') +
    mobileNumber.slice(mobileNumber.length - 2)
  );
};

export const getApplicantName = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else {
    return 'Third';
  }
};

export const minDateForContributor = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export function getOccupationType(occupation?: string | null): boolean {
  return [
    'PVT.SECTOR SERVICE',
    'PUBLIC SECTOR',
    'GOVT.SERVICE',
    'HOUSEWIFE',
    'DEFENCE',
    'PROFESSIONAL',
    'RETIRED',
    'BUSINESS',
    'AGRICULTURE',
    'STUDENT',
    'FOREX DEALER',
    'Salaried',
    'Self Employed',
    'SELF EMPLOYED',
    'Self Employed Professional',
    'Retired',
    'Housewife',
    'Student',
    'Farmer',
    '',
  ].includes(occupation || '');
}

export const getFirstHolderName = (applicants: Partial<Applicant>[]): string => {
  return (
    applicants.find((applicant) => ['firstapplicant', '1'].includes(applicant.applicant_type || ''))
      ?.name || 'N/A'
  );
};

export const getApplicantType = (applicantType: string | undefined): string => {
  if (applicantType) {
    if (['firstapplicant', '1'].includes(applicantType)) {
      return '1';
    } else if (['secondapplicant', '2'].includes(applicantType)) {
      return '2';
    } else {
      return '3';
    }
  }
  return '';
};

export const formatToIndianCurrency = (value: number | null): string => {
  const options = { style: 'currency', currency: 'INR' };
  if (value) {
    return new Intl.NumberFormat('en-IN', options).format(value);
  }
  return '';
};

export function toExactSubstr(str: string): string {
  const a = str.split('.');
  if (a.length == 2) {
    return a[0].concat('.', a[1].substr(0, 2));
  }
  return str;
}

export const formatCurrency = (value?: number | null): string => {
  const formats = ['K', 'L', 'Cr'];
  let amount: any = Number(value);
  formats.some((key, i) => {
    const size = Math.pow(10, i === 0 ? 3 : 3 - 1);
    if (size <= amount) {
      amount = toExactSubstr(`${amount / size}`);
      if (amount >= 100 && i < formats.length - 1) {
        i++;
      } else {
        // amount = (amount * decPlaces) / decPlaces;
        amount += ' ' + formats[i];
        return true;
      }
    } else {
      return true;
    }
  });
  return amount;
};

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const isMinor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS;
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const countryCodes = require('country-codes-list');
export const getCountryCodes = (): { label: string; key: string; countryCode: string }[] => {
  const countryCodesObject: { [key: string]: string } = countryCodes.customList(
    'countryCode',
    '{countryNameEn}: +{countryCallingCode}'
  );

  const modifiedCodes = Object.keys(countryCodesObject).map((cc) => ({
    label: countryCodesObject[cc],
    key: countryCodesObject[cc].split(':')[1].trim(),
    countryCode: cc,
  }));
  return modifiedCodes;
};
export const addressInitialFields = (addressType = '', addressObj = {}): ApplicantAddressType => {
  return {
    address1: Object.keys(addressObj)?.length
      ? (addressObj as ApplicantAddressType)?.address1 || ''
      : '',
    address2: Object.keys(addressObj)?.length
      ? (addressObj as ApplicantAddressType)?.address2 || ''
      : '',
    address3: Object.keys(addressObj)?.length
      ? (addressObj as ApplicantAddressType)?.address3 || ''
      : '',
    city: Object.keys(addressObj)?.length ? (addressObj as ApplicantAddressType)?.city || '' : '',
    district: Object.keys(addressObj)?.length
      ? (addressObj as ApplicantAddressType)?.district || ''
      : '',
    state: Object.keys(addressObj)?.length ? (addressObj as ApplicantAddressType)?.state || '' : '',
    country: Object.keys(addressObj)?.length
      ? (addressObj as ApplicantAddressType)?.country || ''
      : addressType === 'overseas'
      ? ''
      : 'INDIA',
    pincode: Object.keys(addressObj)?.length
      ? (addressObj as ApplicantAddressType)?.pincode || ''
      : '',
    address_type: Object.keys(addressObj)?.length
      ? (addressObj as ApplicantAddressType)?.address_type || ''
      : addressType,
  };
};

export const getAddressFields = (addressType: string): ApplicantAddressType => {
  return {
    ...addressInitialFields(addressType),
    permanentAddressSameAsCorresponding: false,
    isActive: true,
    fetchedFromKRA: null,
    fetchedFromDigiLocker: null,
  };
};

export const enableDisableEsignBasedOnDocId = (application: ApplicationProps) => {
  return (
    application?.applicants?.every((item) =>
      APMIFlow
        ? item.investorConsent === true && !checkTypedDeclaration(item.typedDeclarationCheck)
        : item.investorConsent === true
    ) && !application.leegalityDocumentId
  );
};

export const changeGoalVal = (
  ans: string,
  riskProfileData: updatedRiskProfile[],
  question: string
) => {
  const ansArray = ans.split('*').map((val) => {
    const index = val.indexOf('_');
    const result = val.substring(0, index);
    return result;
  });
  const valueArray = riskProfileData.find((profile) => profile.question === question)?.values;
  const labelsArray = ansArray.map((key) => {
    const item = valueArray?.find((val) => val.key === key);
    return item ? item.label : key;
  });
  return labelsArray.toString();
};

export const getAddressData = (
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  return (
    addresses?.find((address) => address.address_type === addressType) ||
    getAddressFields(addressType)
  );
};

export function getRelation(relationValue?: string | null, saveForLater = true): boolean {
  const relationList = ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister', ''];
  return (!saveForLater ? [...relationList, 'Others'] : relationList).includes(relationValue || '');
}

export function getAmcAuthorisedMaster(num: number) {
  return Array.from({ length: num }, (v, ind) => ind + 1);
}

export const saveForLater = (
  role: string,
  id?: string,
  applicant1ReferenceId?: string | null,
  isAmcuserOnboardedAsInvestor = false
): string => {
  return role === USER_ROLES.INVESTOR || isAmcuserOnboardedAsInvestor
    ? `/investment-details/${applicant1ReferenceId}/application-details`
    : role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER
    ? `/application-details/${id}`
    : '/applications';
};

export const maxAge = (dateOfBirth = ''): boolean => {
  const thisYear = new Date().getFullYear();
  return thisYear - new Date(dateOfBirth).getFullYear() > 125;
};
export const getRemoveOthersConfig = (
  custodian: string,
  createdAt: string,
  removeOthersDate: string
): boolean => {
  return (
    isCustodianICICI(custodian || '') &&
    checkValidationBasedOnDate(createdAt || '', removeOthersDate)
  );
};
export function currencyConversion(num?: string | number | null): string | null {
  if (!num) return '';
  const toWords = new ToWords();
  const words = toWords.convert(Number(num), { currency: true });
  return words;
}

export function checkIfApplicationIsNonIndividual({ applicationType }: ApplicationProps): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

// eslint-disable-next-line
export const preventSpecialCharacters = (e: any) => {
  if (
    !((e.ctrlKey || e.metaKey) && e.keyCode == 67) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 86) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 88) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 90) &&
    !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab'].includes(e.key) &&
    !numberRegex.test(e.key)
  ) {
    e.preventDefault();
  }
};
export function allowOnlyNumbers(e: any): void {
  if (['-', '+', 'e', 'E'].includes(e.key)) {
    e.preventDefault();
  }
}
export const permanentAddressSameAsCorresponding = (
  updatedCorrespondingAddress: Partial<ApplicantAddressType>,
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  // eslint-disable-next-line
  const { address1, address2, address3, city, district, pincode, state, country, ...rest } =
    updatedCorrespondingAddress;
  return {
    ...getAddressData(addressType, addresses),
    address1: address1,
    address2: address2,
    address3: address3,
    city: city,
    pincode: pincode,
    state: state,
    district: district,
    country: country,
    address_type: addressType,
  };
};
export const _updatedAddresses = (
  updatedAddresses: {
    nationality?: string | null | undefined;
    status?: string | null | undefined;
    permanent?: Partial<ApplicantAddressType> | undefined;
    correspondence?: Partial<ApplicantAddressType> | undefined;
    overseas?: Partial<ApplicantAddressType> | undefined;
    [key: string]: string | Partial<ApplicantAddressType> | null | undefined;
  },
  applicant: Partial<Applicant>
): Partial<ApplicantAddressType>[] => {
  const { nationality, status, ...addressProps } = updatedAddresses;
  return Object.keys(addressProps)
    .map((addressType) => {
      // if (applicant.nationality?.toLowerCase() === 'indian' && addressType === 'overseas') {
      //   return {};
      // }
      if (
        addressType === 'permanent' &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['overseas'],
          addressType,
          applicant.addresses
        );
      }
      if (
        addressType === 'permanent' &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding &&
        !addressProps['overseas']
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['correspondence'],
          addressType,
          applicant.addresses
        );
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['overseas'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['correspondence'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      return {
        ...getAddressData(addressType, applicant.addresses),
        ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
        address_type: addressType,
      };
    })
    .flat()
    .filter((address) => Object.keys(address).length);
};
export const applyRoleBasedStatus = (role: any): boolean => {
  return [
    USER_ROLES.RM,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.AMCAPPROVER,
    USER_ROLES.SRM,
  ].includes(role);
};

export const checkKraBasedOnStatus = (status: any): boolean => {
  return ![
    APPLICATION_LISTING_STATUS.invitationexpired,
    APPLICATION_LISTING_STATUS.signed,
    APPLICATION_LISTING_STATUS.completed,
    APPLICATION_LISTING_STATUS.rejected,
  ].includes(APPLICATION_LISTING_STATUS[status]);
};

export const applicationComparison = (
  existingApplication:
    | Partial<ApplicationProps>
    | Partial<getDetailsByRefrenceType>
    | null
    | ApplicantAddressType
    | undefined
    | StrategyDetailsType[],
  updatedApplication:
    | Partial<ApplicationProps>
    | Partial<getDetailsByRefrenceType>
    | ApplicantAddressType
    | undefined
    | StrategyDetailsType[]
): boolean => {
  return _.isEqual(existingApplication, updatedApplication);
};

export const sendApplication_Nri = (application?: ApplicationProps | null): boolean | undefined => {
  return application?.applicants.map((applicant) => applicant.status).includes('NRI');
};

export const checkForCorrespondenceAddress = (
  nationality: string | null | undefined,
  status: string | null | undefined
): boolean => {
  return (
    nationality?.toLowerCase() === 'indian' &&
    (applicantStatusMasters[status as string] === applicantStatusMasters.Individual ||
      status === APPLICANT_STATUS.INDIVIDUAL)
  );
};

export const setUpFeeCalculations = (
  commitmentAmount: number,
  setupFeePercentage: number
): { feeAmount: number; feeGst: number; totalSetupFee: number } => {
  const setupFeeAmount = (Number(commitmentAmount) * Number(setupFeePercentage)) / 100;
  const GstForSetupFee = (setupFeeAmount * 18) / 100;
  return {
    feeAmount: Number(setupFeeAmount),
    feeGst: Number(GstForSetupFee),
    totalSetupFee: Number(setupFeeAmount + GstForSetupFee),
  };
};

export const checkAddressField = (data?: string) => {
  if (data) {
    if (data.includes(' ,')) {
      return data.split(' ,').join(',') + ' ';
    }
    return data.includes(',') ? data + ' ' : data + ', ';
  }
  return '';
};

export const getDisableStatusForjointHolder = (
  role: string,
  applicantType: string,
  isAmcuserOnboardedAsInvestor = false
): boolean => {
  if ((role === USER_ROLES.INVESTOR || isAmcuserOnboardedAsInvestor) && applicantType !== '1') {
    return true;
  }
  return false;
};

export const getBankAddress = (
  address1: string | undefined,
  address2: string | undefined,
  address3: string | undefined
): string => {
  return `${address2 ? checkAddressField(address1) || '' : address1 || '' || ''}${
    address3 ? checkAddressField(address2) || '' : address2 || ''
  }${address3 || ''}`;
};

export const numToAlpMonth = (numMonth: any, month: any) => {
  numMonth?.map((monthNum: any) => {
    if (monthNum === 1) {
      month.push('Jan');
    } else if (monthNum === 2) {
      month.push('Feb');
    } else if (monthNum === 3) {
      month.push('Mar');
    } else if (monthNum === 4) {
      month.push('Apr');
    } else if (monthNum === 5) {
      month.push('May');
    } else if (monthNum === 6) {
      month.push('Jun');
    } else if (monthNum === 7) {
      month.push('Jul');
    } else if (monthNum === 8) {
      month.push('Aug');
    } else if (monthNum === 9) {
      month.push('Sep');
    } else if (monthNum === 10) {
      month.push('Oct');
    } else if (monthNum === 11) {
      month.push('Nov');
    } else if (monthNum === 12) {
      month.push('Dec');
    }
  });
};

export const removeSingleQuote = (value: string | null | undefined): any => {
  if (value && value.includes("'")) return value.split("'").join('');
  else return value;
};

export function removeEqualOperator(value = ''): string {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split('').forEach((char) => {
    if (char !== '=') {
      encodeString += char;
    }
  });
  return encodeString;
}

export const getAge = (Dob: string | null | undefined) => {
  let age;
  if (Dob) {
    const birthDate = new Date(Dob);
    const currentDate = new Date();
    const difference = currentDate.getTime() - birthDate.getTime();
    age = difference / (1000 * 60 * 60 * 24 * 365.25);
  }
  return age;
};

export const checkSendToCheckerNDPMS = (
  showBank: boolean,
  bankFormCreated: boolean,
  checkNDPMS: boolean,
  applyRole: boolean
) => {
  if (!showBank && !bankFormCreated && checkNDPMS && applyRole) {
    return false;
  }
  if (showBank && bankFormCreated && checkNDPMS && applyRole) {
    return false;
  }
  return true;
};

export const turnEditOnInDoc = (
  checkRoute: boolean,
  role: any,
  checkNDPMS: boolean,
  showbank: boolean,
  bankFormcreated: boolean
) => {
  return (
    !checkRoute &&
    [USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.SRM, USER_ROLES.RM].includes(
      role
    ) &&
    checkNDPMS &&
    !showbank &&
    !bankFormcreated
  );
};

export const showSaveButton = (
  ndpmsSectionEdited: boolean,
  showBankIcon: boolean,
  bankAccountFormCreated: boolean,
  role: any,
  checkNdpmsFlow: boolean
) => {
  return (
    [USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.SRM, USER_ROLES.RM].includes(
      role || ''
    ) &&
    ndpmsSectionEdited &&
    checkNdpmsFlow &&
    showBankIcon === bankAccountFormCreated
  );
};

export const checkBankAccoutFieldEnableOrDisalble = (
  checkNDPMS: boolean,
  NDPSMroute: boolean,
  bankAccountFormCreated = false,
  showBankIcon = false
) => {
  return (
    checkNDPMS &&
    ((!bankAccountFormCreated && !showBankIcon) ||
      (bankAccountFormCreated && showBankIcon && !NDPSMroute))
  );
};

export const checkValuePresenceInKeyvalueMaster = (value: any, master: any[]) => {
  return master.some((item) => item.value === value);
};

export const checkNDPMSForIndusindBank = (
  AccountType: string | null | undefined,
  Bank: string | null | undefined
) => {
  return checkNDPMS(AccountType) && Bank === 'IndusInd_Bank';
};

export const checkNDPMS = (AccountType: string | null | undefined) => {
  return AccountType === 'non_discretionary';
};

export const getRiskAgeValue = (age: number | undefined) => {
  if (age) {
    age = Math.round(age);
    if (age >= 0 && age < 30) {
      return 'lessThan30';
    } else if (age >= 30 && age < 45) {
      return 'between30to45years';
    } else if (age >= 45 && age <= 55) {
      return 'between45to55years';
    } else {
      return 'over55years';
    }
  }
  return '';
};

export const timeLineTime = (Data: string) => {
  const timestamp = Data;
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const getScore = (key: string) => {
  if (key === 'lessThan30') {
    return '5';
  } else if (key === 'between30to45years') {
    return '4';
  } else if (key === 'between45to55years') {
    return '3';
  } else if (key === 'over55years') {
    return '2';
  }
  return '';
};

export const checkEditiable = (
  roleType: string,
  role: string,
  applicantIndex: number,
  isAmcuserOnboardedAsInvestor = false
): boolean => {
  if (
    (role === USER_ROLES.INVESTOR || isAmcuserOnboardedAsInvestor) &&
    Number(roleType) !== applicantIndex
  ) {
    return true;
  }
  return false;
};

export function encodeBase64(value: string): string {
  const encodeValue = btoa(value);
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePayload = btoa(`${SALT}${encodeSubString}${SALT2}`);
  return encodePayload;
}

export function getNomineeRelation(relationValue?: string | null, saveForLater = true): boolean {
  const relationList = ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'BROTHER', 'SISTER', ''];
  return (!saveForLater ? [...relationList, 'OTHERS'] : relationList).includes(relationValue || '');
}

export function updatedCommitmentAmount(
  minCommitmentAmount: number,
  applicants: Partial<Applicant>[],
  data: JointholderRelationMaster
): number | void {
  if (applicants.length === 2) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele)
      ?.toString();
    const relation = BloodRelations.includes(applicantRelation) ? applicantRelation : 'Others';
    const amount = data.singleJointHolder
      .map((jointHolder) => {
        if (jointHolder.jointHolder1RelationShip === relation) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
  if (applicants.length === 3) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele);
    const relation = applicantRelation.map((_relation) =>
      BloodRelations.includes(_relation as string) ? _relation : 'Others'
    );
    const amount = data.twoJointHolders
      .map((jointHolder) => {
        if (
          relation[applicants.length - 3] === jointHolder.jointHolder1RelationShip &&
          relation[applicants.length - 2] === jointHolder.jointHolder2RelationShip
        ) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
}

export function checkStrategyBoxSelected(strategyData: updatedStrategyDetails[]): boolean {
  return strategyData?.some((data) => data.isActive === true);
}

export function getTotalStrategyAmount(data: updatedStrategyDetails[]): number | null {
  return data
    ?.filter((strategy) => strategy.isActive)
    ?.map((_strategy) => Number(_strategy.investmentAmount))
    ?.reduce((a: number, b: number) => a + b, 0);
}

export function checkPoaMandateHolder(applicants: Partial<Applicant>[]): boolean {
  return applicants
    .map(
      (applicant) => YesNoMaster[applicant.poaMandateHolderOutsideIndia || ''] !== YesNoMaster.yes
    )
    .every((item) => item);
}

export const futureAge = (dateOfBirth = ''): boolean => {
  return new Date(dateOfBirth) > new Date();
};

export const disableBankDetail = (
  role: any,
  status = '',
  bankAccountFormCreated = false,
  showBankIcon = false
) => {
  return (
    [USER_ROLES.AMCAPPROVER].includes(role) ||
    APPLICATION_LISTING_STATUS[status || ''] !== APPLICATION_LISTING_STATUS.draft ||
    bankAccountFormCreated !== showBankIcon
  );
};

export const getApplicantIdForInvestorPhotoCapture = (
  application: Partial<ApplicationProps> | null,
  applicant1ReferenceId: string
): string => {
  return (
    application?.applicants?.find((applicant) => applicant.referenceId === applicant1ReferenceId)
      ?.id || ''
  );
};
export const roleBasedShowForEdit = (role: USER_ROLES): boolean => {
  return [
    USER_ROLES.RM,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.SRM,
  ].includes(role);
};
export const showPopBankDetail = (
  checkApplication: boolean,
  accountType = '',
  bankAccountFormCreated: boolean,
  showBankIcon: boolean,
  bankDetails: string | null,
  role: any
) => {
  return (
    !checkApplication &&
    checkNDPMS(accountType) &&
    bankAccountFormCreated &&
    showBankIcon &&
    bankDetails === NDPSMBankMaster[bankDetails || ''] &&
    roleBasedShowForEdit(role)
  );
};

export const saveForLaterInvestorPhotoCapture = (
  referenceId: string,
  application: Partial<ApplicationProps> | null
): any => {
  return {
    routePath: `/investor-liveliness/${referenceId}/application-details`,
    routeState: {
      applicationId: application?.id,
      applicantId: getApplicantIdForInvestorPhotoCapture(application, referenceId),
    },
  };
};

export const getInvestorNamesBasedOnPhotoCatureRefId = (applicants: Partial<Applicant>[]) => {
  return applicants
    .filter((applicant) => !applicant.referenceId)
    .map((applicant) => applicant.name);
};

export function applicationDownloadStatusCheck(status: string): boolean {
  return APPLICATION_LISTING_STATUS[status] !== APPLICATION_LISTING_STATUS.completed;
}

export function auditDownloadStatusCheck(status: string): boolean {
  return [APPLICATION_LISTING_STATUS.completed, APPLICATION_LISTING_STATUS.signed].includes(
    APPLICATION_LISTING_STATUS[status]
  );
}

export function amcDownloadStatusCheck(row: ApplicationProps): boolean {
  return auditDownloadStatusCheck(row?.status) || !!row?.signedLeegalityFile?.url;
}

export const fieldValidateForInvestor = (
  roleType: string,
  applicantIndex: number,
  validateJointHolders: boolean
) => {
  if (
    validateJointHolders &&
    (Number(roleType) !== applicantIndex || Number(roleType) === applicantIndex)
  ) {
    return true;
  }
  if (!validateJointHolders && Number(roleType) === applicantIndex) {
    return true;
  }
  return false;
};

export const getInvestorRouteLinks = (
  investorEditSections: InvestorEditErrorObj[],
  currentPath: string,
  referenceDetail?: getDetailsByRefrenceType
): {
  backSectionLink: string;
  saveAndProceedSectionLink: string;
  currentRouteIndex: number;
  backSectionName: string;
} | null => {
  const editSectionRoutes =
    APMIFlow && referenceDetail?.applicant_type === '1'
      ? investorEditSections?.find(
          (menu) => menu.endPoint === investorEditDocumentDetailsObj.endPoint
        )
        ? investorEditEndpointIncludingDoc
        : investorEditEndpointExcludingDoc
      : investorEditSections.map((link) => link.endPoint);
  const getIndex = editSectionRoutes.indexOf(currentPath);
  if (getIndex === -1) {
    return null;
  } else {
    return {
      backSectionLink:
        getIndex === 0 || (APMIFlow && referenceDetail?.applicant_type === '1')
          ? ''
          : editSectionRoutes?.length === 1
          ? ''
          : editSectionRoutes[getIndex - 1],
      saveAndProceedSectionLink:
        editSectionRoutes?.length === 1 ? '' : editSectionRoutes[getIndex + 1],
      currentRouteIndex: getIndex,
      backSectionName:
        getIndex === 0 || (APMIFlow && referenceDetail?.applicant_type === '1')
          ? ''
          : editSectionRoutes?.length === 1
          ? ''
          : investorEditSections[getIndex - 1].tabText,
    };
  }
};
export const documentNameValidationCheckForMultipleDocumentsMandatory = (documentName: string) => {
  return ['Voter ID Card', 'Passport', "Voter's ID", 'Passport Copy (1st and last page)'].includes(
    documentName
  );
};

export const isBankDetailsChanged = (
  initialValues: string | null | undefined,
  currentValues: string | null | undefined
) => {
  return (
    NDPSMBankMaster[initialValues || ''] === NDPSMBankMaster.None &&
    NDPSMBankMaster[currentValues || ''] === NDPSMBankMaster.IndusInd_Bank
  );
};

export const CheckRegenrationButtonDisable = (application: ApplicationProps) => {
  if (
    application &&
    ((!checkIfApplicationIsNonIndividual(application) &&
      getConsentDetails(application?.applicants).consentStatus ===
        APPLICATION_LISTING_STATUS.completed) ||
      (checkIfApplicationIsNonIndividual(application) &&
        application?.groups &&
        application?.groups.length > 0 &&
        getAuthorizedSignatoriesConsentDetails(application?.groups).consentStatus ===
          APPLICATION_LISTING_STATUS.completed)) &&
    !application?.leegalityDocumentId
  ) {
    return false;
  }
  return true;
};

export const isValidPan = (pan: string): boolean =>
  [individualPanRegex, nonIndividualPanRegex].some((pattern) => pattern.test(pan));

export const isApplicantNRI = (status: string): boolean => {
  return applicantStatusMasters[status || ''] === applicantStatusMasters.NRI;
};

export const isCustodianICICI = (custodian: string): boolean =>
  custodian?.toLowerCase() === 'icici';

export const isCustodianICICIOrHDFC = (custodian: string): boolean =>
  ['icici', 'hdfc'].includes(custodian?.toLowerCase());

export const isCustodianHDFC = (custodian: string): boolean =>
  ['hdfc'].includes(custodian?.toLowerCase());

export const isCustodianOrbis = (custodian: string): boolean =>
  ['orbis'].includes(custodian?.toLowerCase());

export function isPendingByAMCAuthorisedSignatory(status: string): boolean {
  return AMC_AUTHORISED_SIGNATORY_STATUS.includes(status);
}
export const isCustodianNuvuma = (custodian: string): boolean =>
  ['edelweiss'].includes(custodian?.toLowerCase());
export const isCustodianAxis = (custodian: string): boolean =>
  ['axis'].includes(custodian?.toLowerCase());
export const isBankAccountProofUploadedFromBankSection = (
  ind: number,
  documentType: string,
  banks: Bank[]
): boolean => {
  return !!(
    documentType === 'bankAccountProof' &&
    ind === 0 &&
    banks?.find((bank) => bank.defaultBankAccount)?.documentId
  );
};

export const checkValidationBasedOnDate = (
  date: string | number | Date,
  validationStartDate: string
): boolean => {
  if (!date) return false;
  if (!validationStartDate) return true;
  const dateForCompare = date ? new Date(date) : new Date();
  const dateForApplyValidations = new Date(validationStartDate);
  return dateForCompare.getTime() >= dateForApplyValidations.getTime();
};

export const checkForMaritalStatusOthers = (
  selectedCustodian: string,
  maritalStatus: string | null
): boolean => {
  if (!selectedCustodian || !maritalStatus) {
    return false;
  }
  return (
    isCustodianICICI(selectedCustodian) &&
    maritalStatusMasters[maritalStatus || ''] === maritalStatusMasters.Others
  );
};

export function shouldValidateUponSaveLater(saveType: string): boolean {
  return (
    (saveType === 'save for later' && SAVE_LATER_VALIDATION_CHECK) || saveType !== 'save for later'
  );
}

export function getStep(currentStep: number, isSaveLater: boolean): number {
  return !SAVE_LATER_VALIDATION_CHECK && isSaveLater ? currentStep - 1 : currentStep;
}

export const isApplicantPEPOrRPEP = (value: string): boolean => {
  return ['I am PEP', 'I am Related to PEP'].includes(value || '');
};

export const sortOptionsInAlphabeticOrder = (
  items: { key: string | number; value: string | number }[]
): { key: string | number; value: string | number }[] => {
  const others = items.filter(
    (item) =>
      item.value.toString().toLowerCase() === 'other' ||
      item.value.toString().toLowerCase() === 'others'
  );

  const filteredItems = items.filter(
    (item) =>
      item.value.toString().toLowerCase() !== 'other' &&
      item.value.toString().toLowerCase() !== 'others'
  );

  filteredItems.sort((a, b) => a.value.toString().localeCompare(b.value.toString()));

  return [...filteredItems, ...others];
};
// This code defines a function getKey that takes an object as input and returns a new object with the same keys as the input object but with the key as the value.
export const getKey = (master: { [key: string]: string }): { [key: string]: string } => {
  const setValueAsKey: { [key: string]: string } = {};

  for (const key in master) {
    if (Object.prototype.hasOwnProperty.call(master, key)) {
      setValueAsKey[key] = key;
    }
  }
  return setValueAsKey;
};

export const checkNDPMFlow = (val: string): boolean => {
  return ACCOUNT_TYPE_OPTIONS[val] === ACCOUNT_TYPE_OPTIONS.non_discretionary;
};
export const checkDPMSFlow = (val: string): boolean => {
  return ACCOUNT_TYPE_OPTIONS[val] === ACCOUNT_TYPE_OPTIONS.discretionary;
};
export const RemoveAsterikFromstring = (val: string): string => {
  if (val.includes('*')) {
    return val.replace(/\*/g, '');
  }
  return val;
};

export const checkAsterikInString = (val: string): boolean => {
  if (val.includes('*')) {
    return true;
  }
  return false;
};

export const getAllStrategiesByDistributorType = async (
  dispatch: any,
  application: ApplicationProps
): Promise<GetStrategiesResponseBody[]> => {
  const accountTypeMaster = getKey(ACCOUNT_TYPE_OPTIONS);
  const provideTypeMaster = getKey(distributorMaster);
  const distributorId = application?.distributor_id;
  const accountType = application?.accountType || '';
  const isDPMS = checkDPMSFlow(accountType);
  const isNDPMS = checkNDPMFlow(accountType);
  const applicableFlowType = isDPMS
    ? accountTypeMaster.discretionary
    : accountTypeMaster.non_discretionary;

  const commonPayload = {
    isActive: true,
    isDPMSFlow: isDPMS,
    applicableFlowType,
    isNDPMSFlow: isNDPMS,
  };

  const isRiaDistributor = checkApplicableForYes(application?.distributor?.isRia || '');

  if (distributorId) {
    const payload = {
      ...commonPayload,
      distributorId,
      isApplicableForDistributor: !isRiaDistributor,
      isApplicableForRia: isRiaDistributor,
      applicableForType: isRiaDistributor ? provideTypeMaster.RIA : provideTypeMaster.Distributor,
    };
    return (await dispatch(getStrategies(payload))) as unknown as GetStrategiesResponseBody[];
  } else if (application?.rm_id) {
    const payload = {
      ...commonPayload,
      isApplicableForDirect: true,
      applicableForType: provideTypeMaster.Direct,
    };
    return (await dispatch(getStrategies(payload))) as unknown as GetStrategiesResponseBody[];
  } else {
    return [];
  }
};

export const isCustodianKotak = (custodian: string): boolean =>
  custodian?.toLowerCase() === 'kotak';
export const IsRiskFieldTextfield = (questionType: string): boolean => questionType === 'textField';
export const displayInputFieldWithLabel = (question: string): boolean =>
  ['investmentHorizon'].includes(question);
export const checkApplicableForYes = (val: string): boolean => {
  return YesNoMaster[val || ''] === YesNoMaster.yes;
};

export const getNomineeIdTypes = (idTypeDateBaseCheck: boolean): { [key: string]: string } => {
  return idTypeDateBaseCheck
    ? nomineeIdTypes?.withDateBaseCheck
    : nomineeIdTypes?.withoutDateBaseCheck;
};
export function formatDOBToISOString(dateOfBirth?: string | null): string {
  if (!dateOfBirth) return '';
  const dob = new Date(dateOfBirth);
  if (isNaN(dob.getTime())) return '';
  dob.setHours(12, 0, 0, 0);
  return dob.toISOString();
}
export const nomineeDocEditCheck = (applicant_type: string, role: string): boolean => {
  return role !== USER_ROLES.INVESTOR;
};
export const dematdeclarationforIcici = (
  custodian: string,
  autodematdeclaration: string,
  createdAt: string,
  applicant_type: string
): boolean => {
  return (
    isCustodianICICI(custodian) &&
    checkValidationBasedOnDate(createdAt, autodematdeclaration) &&
    applicant_type === '1'
  );
};
export const updatePageTitle = (path: string) => {
  const pathSegments = path.split('/').filter(Boolean);
  const lastSegment = pathSegments[pathSegments.length - 1];

  const pageTitle =
    lastSegment
      ?.split('-')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ') || 'PMS';

  document.title = `Angel One :: ${pageTitle}`;
};
